import axios from "axios";
import React, { useEffect, useState, useRef } from "react";

const AmenitiesModal = ({
  closeModal,
  emitterEvent,
  handleInputChange,
  formData,
}) => {
  const [modalContent, setModalContent] = useState([]);
  const [selectedItems, setSelectedItems] = useState(formData.propertyDetails.amenities);
  const [isCollapsedFlat, setIsCollapsedFlat] = useState(true);
  const [isCollapsedSociety, setIsCollapsedSociety] = useState(true);
  const flatRef = useRef(null);
  const societyRef = useRef(null);

  const toggleSelection = (id) => {
    setSelectedItems((prevSelected) => {
      const updatedSelection = prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id];

      const selectedSociety = modalContent
        .filter(
          (item) =>
            updatedSelection.includes(item.id) && item.ameniti_category_id === 2
        )
        .map((item) => item.name)
        .join(", ");

      const selectedFurnishes = modalContent
        .filter(
          (item) =>
            updatedSelection.includes(item.id) && item.ameniti_category_id === 1
        )
        .map((item) => item.name)
        .join(", ");

      handleInputChange("propertyDetails", "amenities", updatedSelection);
      handleInputChange(
        "propertyDetails",
        "amenities_furnishes",
        selectedFurnishes
      );
      handleInputChange(
        "propertyDetails",
        "amenities_society",
        selectedSociety
      );

      return updatedSelection;
    });
  };

  // Prefill amenities_furnishes and amenities_society on load
  useEffect(() => {
    if (modalContent.length && selectedItems.length) {
      const selectedSociety = modalContent
        .filter(
          (item) =>
            selectedItems.includes(item.id) && item.ameniti_category_id === 2
        )
        .map((item) => item.name)
        .join(", ");

      const selectedFurnishes = modalContent
        .filter(
          (item) =>
            selectedItems.includes(item.id) && item.ameniti_category_id === 1
        )
        .map((item) => item.name)
        .join(", ");

      handleInputChange(
        "propertyDetails",
        "amenities_society",
        selectedSociety
      );
      handleInputChange(
        "propertyDetails",
        "amenities_furnishes",
        selectedFurnishes
      );
    }
  }, [modalContent, selectedItems]);

   useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/getAmenities/list`)
      .then((response) => {
        setModalContent(response.data.data || []);
      })
      .catch((error) => console.error("Error fetching projects:", error));
  }, []);

  if (emitterEvent) {
    setTimeout(() => {
      closeModal();
    }, 2000);

    return;
  }
  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{
          display: "block",
          background: "rgba(0, 0, 0, 0.5)",
        }}
        aria-labelledby="exampleModalLabel"
        aria-hidden="false"
      >
        <div className="d-flex justify-content-center align-items-center vh-100">
          <div className="modal-content p-3" style={{ width: "1000px" }}>
            <div className="modal-body">
              {/* Close Button */}
              <button
                type="button"
                className="btn-close-amenities"
                onClick={closeModal}
                aria-label="Close"
              >
                <i className="fa fa-times"></i>
              </button>

              {/* Flat Furnishes */}

              {modalContent.filter((item) => item.ameniti_category_id === 1) // Filter by ameniti_category_id = 1
                .length === 0 ? (
                <></>
              ) : (
                <>
                  <div className="mb-4 d-flex justify-content-between accord_header">
                    <h2>Flat Furnishes</h2>
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => setIsCollapsedFlat(!isCollapsedFlat)}
                    >
                      <svg
                        width="14"
                        height="9"
                        viewBox="0 0 12 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          transform: isCollapsedFlat
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "0.3s",
                        }}
                      >
                        <path
                          d="M10.6199 1.2207L6.81655 5.02404C6.36738 5.4732 5.63238 5.4732 5.18322 5.02404L1.37988 1.2207"
                          stroke="#1B4E9B"
                          strokeWidth="2"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <div
                    ref={flatRef}
                    className={`collapse-container ${
                      isCollapsedFlat ? "open" : "closed"
                    }`}
                    style={{ textAlign: "left" }}
                  >
                    {modalContent
                      .filter((item) => item.ameniti_category_id === 1) // Filter by category_id = 2
                      .map((item) => (
                        <button
                          key={item.id}
                          className={`btn-amenitie ${
                            selectedItems.includes(item.id)
                              ? "selected-box"
                              : ""
                          }`}
                          onClick={() => toggleSelection(item.id)}
                          style={{ cursor: "pointer", margin: "4px" }}
                        >
                          {item.name}
                        </button>
                      ))}
                  </div>
                </>
              )}

              {/* Society Amenities */}

              {modalContent.filter((item) => item.ameniti_category_id === 2) // Filter by ameniti_category_id = 2
                .length === 0 ? (
                <></>
              ) : (
                <>
                  <div className="mb-4 d-flex justify-content-between accord_header">
                    <h2>Society Amenities</h2>
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => setIsCollapsedSociety(!isCollapsedSociety)}
                    >
                      <svg
                        width="14"
                        height="9"
                        viewBox="0 0 12 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          transform: isCollapsedSociety
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "0.3s",
                        }}
                      >
                        <path
                          d="M10.6199 1.2207L6.81655 5.02404C6.36738 5.4732 5.63238 5.4732 5.18322 5.02404L1.37988 1.2207"
                          stroke="#1B4E9B"
                          strokeWidth="2"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <div
                    ref={societyRef}
                    className={`collapse-container ${
                      isCollapsedSociety ? "open" : "closed"
                    }`}
                    style={{ textAlign: "left" }}
                  >
                    {modalContent
                      .filter((item) => item.ameniti_category_id === 2) // Filter by category_id = 2
                      .map((item) => (
                        <button
                          key={item.id}
                          className={`btn-amenitie ${
                            selectedItems.includes(item.id)
                              ? "selected-box"
                              : ""
                          }`}
                          onClick={() => toggleSelection(item.id)}
                          style={{ cursor: "pointer", margin: "4px" }}
                        >
                          {item.name}
                        </button>
                      ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AmenitiesModal;
